import analytics from '@/analytics/home/home.analytics';

const LINK_BEHAVIOR = {
  SAME_TAB: 'same_tab',
  NEW_TAB: 'new_tab',
  NEW_WINDOW: 'new_window',
  FUNCTION: 'function',
};

const MODULES = {
  HIGHLIGHT: 'Highlight',
  ADVERTISEMENTS: 'Advertisements',
  BANNER: 'Banner',
  RESOURCES: 'Resources',
  HIRED_PRODUCTS: 'HiredProducts',
};

const RESOURCES_ELEMENTS = {
  RESOURCES: 'Resources',
  CARD_RESOURCE_IMAGE: 'CardResourceImage',
  CARD_RESOURCE: 'CardResource',
};

const PRODUCTS_HIGHLIGHT_IDS = {
  SITE_CREATOR: 2,
  EMAIL_TITAN: 3,
  HG_STUDIO_PRO_TRIAL: 12,
  HG_STUDIO_PRO: 13,
  HG_STUDIO_FREE: 14,
  HG_BUILDER: 15,
  VPS_N8N: 99,
  AI_AGENTS: 98,
};

const ALL_STUDIO_HIGHLIGHTS_IDS = [
  PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO_TRIAL,
  PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO,
  PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_FREE,
];

const TAB_NAME_TO_ID = {
  'vps-n8n': PRODUCTS_HIGHLIGHT_IDS.VPS_N8N,
  studio: ALL_STUDIO_HIGHLIGHTS_IDS,
  // Portuguese (BR)
  'criar-site': PRODUCTS_HIGHLIGHT_IDS.SITE_CREATOR,
  'email-profissional': PRODUCTS_HIGHLIGHT_IDS.EMAIL_TITAN,
  'hostgator-studio': ALL_STUDIO_HIGHLIGHTS_IDS,
  // Spanish (ES)
  'crear-sitio-web': PRODUCTS_HIGHLIGHT_IDS.SITE_CREATOR,
  'emails-list': PRODUCTS_HIGHLIGHT_IDS.EMAIL_TITAN,
  'ai-agents': PRODUCTS_HIGHLIGHT_IDS.AI_AGENTS,
};

const HIGHLIGHT_ID_TO_ANALYTICS_KEY = {
  [PRODUCTS_HIGHLIGHT_IDS.SITE_CREATOR]: analytics.directAccessCreateSiteTab,
  [PRODUCTS_HIGHLIGHT_IDS.EMAIL_TITAN]: analytics.directAccessEmailProTab,
  [PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO_TRIAL]: analytics.directAccessStudioTab,
  [PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO]: analytics.directAccessStudioTab,
  [PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_FREE]: analytics.directAccessStudioTab,
  [PRODUCTS_HIGHLIGHT_IDS.VPS_N8N]: analytics.directAccessVpsN8nTab,
};

export {
  LINK_BEHAVIOR,
  MODULES,
  RESOURCES_ELEMENTS,
  PRODUCTS_HIGHLIGHT_IDS,
  ALL_STUDIO_HIGHLIGHTS_IDS,
  TAB_NAME_TO_ID,
  HIGHLIGHT_ID_TO_ANALYTICS_KEY,
};
